/**
 * Resolves the portfolio datepicker `disabledBeforeDate`.
 * Prefer API `availableDateRange.startDate` when present; otherwise tree later-of start.
 */
export function resolvePortfolioDisabledBeforeDate({
  availableDateRangeStartDate,
  treeDisabledBeforeDate,
}: {
  availableDateRangeStartDate?: string | null;
  treeDisabledBeforeDate?: string | null;
}): string | null {
  return availableDateRangeStartDate || treeDisabledBeforeDate || null;
}
